export default __webpack_public_path__ + "static/media/Holcim_Startup_Maqer_Logo_RGB_lime_neg.9a875699.png";